const translations = {
  "en": {
    "Hi — I’m Ed. Sign in and I hand you the pack. No forms first.": "Hi — I’m Ed. Sign in and I hand you the pack. No forms first.",
    "One ranking, a rating on every stock. Sign in and it’s yours.": "One ranking, a rating on every stock. Sign in and it’s yours.",
    "Your %{var0} ranking pack is ready.": "Your %{var0} ranking pack is ready.",
    "Your ranking pack is ready.": "Your ranking pack is ready."
  },
  "zh-tw": {
    "Hi — I’m Ed. Sign in and I hand you the pack. No forms first.": "嗨，我是 Ed。登入就能取得資料包，不用先填問卷。",
    "One ranking, a rating on every stock. Sign in and it’s yours.": "一份榜單，每檔股票都有評分。登入即可查看。",
    "Your %{var0} ranking pack is ready.": "你的%{var0}排名資料包已準備好。",
    "Your ranking pack is ready.": "你的排名資料包已準備好。"
  }
};

export default translations;
